import React, { useContext } from "react";
import { matchPath, useHref, useLinkClickHandler } from "react-router-dom";
import { urls } from "../../..";
import { concatUrlPathnames, removeMultipleSlashes } from "../../../data/sport-utils";
import { getConfiguration } from '../../../data/utils/configuration';
import { getEncodedURI } from '../../../data/utils/getEncodedURI';
import { appConfig } from "../../../appConfig";
import { getPathnameRouteInfo } from "./seoUtils";
import { XRouterNavigateContext } from "./XRouterNavigateContext";
import { XRouterContext } from "./XRouterContext";

 function getXRouterPath(base,path,parents,pathSeo) {
    let toReturn = '';
    try {
        
        let p;
        let m;

        if(getConfiguration().seo && (pathSeo || null) != null) {
            pathSeo = getEncodedURI(pathSeo);
            if(pathSeo.startsWith('/')) {
                toReturn = pathSeo;
            }else{
                toReturn = concatUrlPathnames(base, pathSeo);
            }
        }else{
            p = base==path?base:concatUrlPathnames(base, path);
            if(appConfig.URL_PATH_MAPPINGS) {
                m = Object.keys(appConfig.URL_PATH_MAPPINGS).find(function(k) {return appConfig.URL_PATH_MAPPINGS[k]==p});
            }
            if(window.seoConfig && window.seoConfig.ump && parents) {
                parents.forEach(function(parent) {
                    let s = concatUrlPathnames(base || "", parent['path'],parent['suffix']);
                    //let ms = Object.keys(appConfig.URL_PATH_MAPPINGS).find(function(k) {return appConfig.URL_PATH_MAPPINGS[k]==s});
                    let ms = Object.keys(window.seoConfig.ump).find(function(k) {return window.seoConfig.ump[k]==s});
                    if(ms) {
                        p = p.replace(concatUrlPathnames(base,parent['path']),ms);
                    }
                })
            }
            toReturn = m || p;
        }
    }catch(err) {
        console.log(err);
        toReturn = '';
    }
    
    return toReturn;
}

function isLiveSportPath(path) {
    const liveSportPath =  matchPath({
        path: removeMultipleSlashes(`${urls.base}/${urls.live.base}/:sportId`),
        end: true,
        caseSensitive: false
    },path);

    return liveSportPath?.params?.sportId;
}

function isPrematchSportPath(path) {
    const prematchSportPath =  matchPath({
        path: removeMultipleSlashes(`${urls.base}/${urls.prematch.base}/:sportId`),
        end: true,
        caseSensitive: false
    },path);

    return prematchSportPath?.params?.sportId;
}

function isPrematchTournamentPath(path) {
    const prematchTournamentPath =  matchPath({
        path: removeMultipleSlashes(`${urls.base}/${urls.prematch.base}/${urls.prematch.tournament}/:id`),
        end: true,
        caseSensitive: false
    },path);

    return prematchTournamentPath?.params?.id;
}

function isPrematchEventPath(path) {
    const prematchEventPath =  matchPath({
        path: removeMultipleSlashes(`${urls.base}/${urls.prematch.base}/${urls.prematch.tournament}/:tournamentId/${urls.prematch.event}/:eventId`),
        end: true,
        caseSensitive: false
    },path);

    return prematchEventPath?.params?.tournamentId && prematchEventPath?.params?.eventId;
}

function isPrematchEventMacroPath(path) {
    const prematchEventMacroPath =  matchPath({
        path: removeMultipleSlashes(`${urls.base}/${urls.prematch.base}/${urls.prematch.tournament}/:tournamentId/${urls.prematch.event}/:eventId/:macroId`),
        end: true,
        caseSensitive: false
    },path);

    return prematchEventMacroPath?.params?.tournamentId && prematchEventMacroPath?.params?.eventId && prematchEventMacroPath?.params?.macroId;
}

function getSportLivePath(sport) {
    const path = `${sport.urlPath}${sport.urlPathSuffix}`;
    const pathSeo =  sport.urlPathSeoLive;
    return getXRouterPath(removeMultipleSlashes(`${urls.base}/${urls.live.base}`),path,null,pathSeo) ;

}

function getSportPath(sport) {
    const path = `${sport.urlPath}${sport.urlPathSuffix}`;
    const pathSeo =  sport.urlPathSeo;
    return getXRouterPath(removeMultipleSlashes(`${urls.base}/${urls.prematch.base}`),path,null,pathSeo) ;

}

export function getTournamentPath(tournament) {
    const path = `${tournament.urlPath}${tournament.urlPathSuffix}`;
    const pathSeo =  tournament.urlPathSeo;
    return getXRouterPath(removeMultipleSlashes(`${urls.base}/${urls.prematch.base}`),path,null,pathSeo) ;

}

export function getEventPath(event) {
    const path = `${event.urlPath}`;
    const pathSeo =  event.urlPathSeo;
    return getXRouterPath(removeMultipleSlashes(`${urls.base}/${urls.prematch.base}`),path,null,pathSeo) ;

}

function getEventMacroPath(event,macroId) {
    const path = `${event.urlPath}_m${macroId}`;
    //const pathSeo =  `${event.urlPathSeo}_m${macroId}`;
    const pathSeo = null; // URL for macroId not handled in XSeo
    return getXRouterPath(removeMultipleSlashes(`${urls.base}/${urls.prematch.base}`),path,null,pathSeo) ;

}

export function getLinkAttrs(to,data) {
    let noFollow = true;
    let macroId;

    if(data) {
        if(isLiveSportPath(to)) {
            to = getSportLivePath(data)
            noFollow = data?.urlPathSeoSettings?.nf || false;
        }else if(isPrematchSportPath(to)) {
            to = getSportPath(data)
            noFollow = data?.urlPathSeoSettings?.nf || false;
        }else if(isPrematchTournamentPath(to)) {
            to = getTournamentPath(data)
            noFollow = data?.urlPathSeoSettings?.nf || false;
        }else if(isPrematchEventPath(to)) {
            to = getEventPath(data)
            noFollow = data?.urlPathSeoSettings?.nf || false;
        }else if(macroId = isPrematchEventMacroPath(to)) {
            to = getEventMacroPath(data,macroId)
            noFollow = data?.urlPathSeoSettings?.nf || false;
        }
    }else {
        const [route] = getPathnameRouteInfo(to);
        if(route) {
            noFollow = false
        }
    }
    return [to,noFollow];
}

export function useXRouterUrl(url,data) {
    const xrouterContext =  useContext(XRouterContext);
    let urlTo = removeMultipleSlashes(url);
    let noFollow;

    if(xrouterContext.legacy) {
        [urlTo] = getLinkAttrs(removeMultipleSlashes(url), data);
    }

    return urlTo;
}

function XRouterLink(props) {
    const xrouterContext =  useContext(XRouterContext);
    const xrouterNavigateContext = useContext(XRouterNavigateContext);

    function navigateTo(url,state,isRelative,e) {
        if(xrouterContext.legacy) {
            e.preventDefault();
            e.stopPropagation();
            /*if(isRelative && !conf.seo) {
                url = concatUrlPathnames(window.location.pathname,url);
            }*/
            window.history.pushState(window.history.state, null, url)
            xrouterNavigateContext.navigate(url,{'replace':true,data:state, state:state},true);
            //window.history.pushState(window.history.state, null, url)
            //navigate(concatUrlPathnames(urls.basename,handleUrlRewrite(url)),{'replace':true,state:state});
        }
    }

    let linkTo = removeMultipleSlashes(props.to);
    let noFollow;

    if(xrouterContext.legacy) {
        [linkTo,noFollow] = getLinkAttrs(removeMultipleSlashes(props.to), props.data);
    }

    const XLink = React.forwardRef(
        (
          {
            onClick,
            replace = false,
            state,
            target,
            to,
            ...rest
          },
          ref
        ) => {
          let href = useHref(getEncodedURI(removeMultipleSlashes(linkTo)));
          let handleClick = useLinkClickHandler(to, {
            replace,
            state,
            target,
          });
          delete rest.data;
          delete rest.isrelative;
          return (
            <a
              {...rest}
              href={href}
              onClick={(event) => {
                onClick?.(event);
                navigateTo(href,props.state,props.isrelative,event);
                if (!event.defaultPrevented) {
                  handleClick(event);
                }
              }}
              ref={ref}
              target={target}
            />
          );
        }
      );

      return <XLink {...props} {...(noFollow ? {rel: 'nofollow,noindex'}:{})} />

    //let propsCopy = {...props} ;
    //delete propsCopy.to;
    
    /*return (
        <Link  {...props}  to={encodeURI(to)} onClick={(e)=>navigateTo(to,props.state,props.relative,e)} {...(noFollow ? {rel: 'nofollow'}:{})}/>
    )*/

}

export default XRouterLink;
